<template>
  <div v-outside-click="closeDropDown" class="dropdown__Wrapper" @click="toggleDropDown">
    <div class="kk-designer-view__btn">
      <slot></slot>
    </div>

    <div v-if="visibility" ref="dropdown" class="dropdown" :style="{ height: items.length > 5 ? '13rem' : '' }">
      <div
        v-for="(item, i) in items"
        :key="i"
        class="dropdown__item"
        :class="{ 'dropdown__item-active': i === index }"
        :title="item.title"
        :data-test-id="item.testId"
        @click="callFunction($event, item, i)"
      >
        <img v-if="item.code" :class="item.imgClass" :src="require(`@/assets/flags/${item.code}.svg`)" alt="" />
        <span class="dropdown__item-icon" :class="item.icon" :style="item.style"></span>
        <div class="dropdown__item-text">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import hotkeys from "hotkeys-js";
import { HotkeyScopes } from "../../../utils/constants";
import { icons } from "../../../utils/icons";

export default {
  props: {
    items: Array,
    visibility: Boolean,
    title: String,
    activeIndex: Number,
    testId: String,
  },
  emits: ["toggle-dropdown"],
  data() {
    return {
      index: this.activeIndex,
      previousScope: null,
      icons: icons,
      previousIndex: null,
    };
  },
  watch: {
    activeIndex(newValue, oldValue) {
      this.index = newValue;
    },
    visibility(newValue, oldValue) {
      if (newValue) {
        this.setScopes();
      } else {
        this.unsetScopes();
      }
    },
  },
  methods: {
    toggleDropDown() {
      this.$emit("toggle-dropdown", !this.visibility);
    },
    closeDropDown() {
      this.$emit("toggle-dropdown", false);
    },
    callFunction(event, item, index) {
      this.index = index;
      item.func && item.func(item);
    },
    enter(event, handler) {
      event.preventDefault();
      const item = this.items[this.index];
      this.callFunction(event, item, this.index);
      this.closeDropDown();
    },
    moveDown(event) {
      event.preventDefault();
      this.index = (this.index + 1) % this.items.length;
    },
    moveUp(event) {
      event.preventDefault();
      this.index = this.index <= 0 ? this.items.length - 1 : (this.index - 1) % this.items.length;
    },
    setScopes() {
      this.previousScope = hotkeys.getScope();
      this.$store.dispatch("setScope", HotkeyScopes.DropDown);

      hotkeys("up", HotkeyScopes.DropDown, this.moveUp);
      hotkeys("down", HotkeyScopes.DropDown, this.moveDown);
      hotkeys("enter", HotkeyScopes.DropDown, this.enter);
      hotkeys("escape", HotkeyScopes.DropDown, () => {
        this.closeDropDown();
        this.setPreviousScope();
      });
    },
    unsetScopes() {
      this.$store.dispatch("setScope", HotkeyScopes.ProcessDesigner);
      hotkeys.unbind("up, down, enter, escape", HotkeyScopes.DropDown);
    },
    setPreviousScope() {
      this.$store.dispatch("setScope", HotkeyScopes.ProcessDesigner);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables";

::-webkit-scrollbar {
  width: 4px;
  height: 10px;
}

.kk-designer-view {
  &__btn {
    display: flex;
    gap: 0.2rem;
    align-items: center;
    cursor: pointer;
    margin: 0 0.4rem;
  }
}

.dropdown {
  &__wrapper {
    position: relative;
  }

  width: 14rem;
  overflow-y: auto;
  overflow-x: hidden;
  background: @kk-color-white;
  position: absolute;
  transform: translate(-40%, 0%);
  top: 100%;
  z-index: 200;
  box-shadow: @kk-primary-box-shadow;
  border-radius: 4px;

  &__item {
    font-family: "FiraSans-Regular", "Fira Sans", sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: @kk-color-gray;
    text-rendering: optimizeLegibility;
    position: relative;
    display: flex;
    gap: 0.4rem;
    align-items: center;
    padding: 0.5rem 0.4rem;
    height: 40px;
    cursor: pointer;

    img {
      width: 2rem;
    }

    &-icon {
      font-size: 18px;
      margin: 0 5px;
    }
    &-text {
      flex-grow: 1;
    }
    &:not(&-active)&:hover {
      background-color: @kk-color-light-blue;
    }

    &-active {
      background-color: @kk-color-primary-blue;
      border-bottom: 2px solid @kk-color-primary-blue;
      color: @kk-color-white;
    }
  }
}
</style>
